import React, { useEffect, useState } from "react";
import classes from "./Section6.module.css";
import ProductCard from "../../../components/ProductCard";
import ProductCardSkeleton from "../../../components/ProductCardSkeleton";
import API from "../../../utils/api";
import SliderComp from "../../../components/SliderComp";

export default function Section6() {
  const [latestProducts, setLatestProducts] = useState([]);
  const [bestProducts, setBestProducts] = useState([]);
  const [activeTab, setActiveTab] = useState("latest");
  const [loading, setLoading] = useState(true);

  const tabs = [
    { key: "latest", label: "Latest Products" },
    { key: "best", label: "Best Selling Products" },
  ];

  const getImageUrl = (imageName) => {
    const baseUrl = API.base.endsWith("/techmatter_api")
      ? API.base
      : `${API.base}/techmatter_api`;
    return imageName
      ? `${baseUrl}/upload/${imageName}`
      : `${baseUrl}/upload/placeholder-image.jpg`;
  };

  const fetchProductsByCategorySlug = async (
    categorySlug,
    limit = 5,
    sortBy = ""
  ) => {
    try {
      const formData = new URLSearchParams({
        action: "fetch",
        category_slug: categorySlug,
        limit: limit.toString(),
        status: "publish",
      });

      if (sortBy) formData.append("sort_by", sortBy);

      const res = await fetch(`${API.base}/products.php`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData,
      });
      const data = await res.json();
      if (!data || !Array.isArray(data)) return [];

      return data.map((p) => ({
        ...p,
        productImage: getImageUrl(p.productImage),
        regularPrice: parseFloat(p.regularPrice) || 0,
        salePrice: parseFloat(p.salePrice) || 0,
      }));
    } catch (err) {
      console.error(`Failed to fetch products for ${categorySlug}:`, err);
      return [];
    }
  };

  useEffect(() => {
    let mounted = true;

    const fetchAllProducts = async () => {
      setLoading(true);

      // Fetch only the required categories with limits
      const [latest, best] = await Promise.all([
        fetchProductsByCategorySlug("server-memory", 5, "latest"),
        fetchProductsByCategorySlug("network-switches", 5, "totalOrder"), // assuming API supports best selling
      ]);

      if (mounted) {
        setLatestProducts(latest);
        setBestProducts(best);
        setLoading(false);
      }
    };

    fetchAllProducts();

    return () => {
      mounted = false;
    };
  }, []);

  const productsToShow = activeTab === "latest" ? latestProducts : bestProducts;

  return (
    <div className={classes.section6Wrapper}>
      {/* Tabs */}
      <div className={classes.tabsRow}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`${classes.tabBtn} ${
              activeTab === tab.key ? classes.active : ""
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Products Slider */}
      <div className={classes.productsCard}>
        {loading ? (
          <ProductCardSkeleton count={4} />
        ) : productsToShow.length > 0 ? (
          <SliderComp slidesToShow={4}>
            {productsToShow.map((p) => (
              <div key={p.id} className={classes.sliderItem}>
                <ProductCard product={p} />
              </div>
            ))}
          </SliderComp>
        ) : (
          <p className={classes.noProduct}>No products found for this tab.</p>
        )}
      </div>
    </div>
  );
}
